import {
	ADMINUPDATEMODULEALLOCATION_SUCCESS,
	ADMINUPDATEMODULEALLOCATION_FAILED,
	RESET_ADMINUPDATEMODULEALLOCATION,
	LOADING_ADMINUPDATEMODULEALLOCATION,
	NETWORK_ERROR_ADMINUPDATEMODULEALLOCATION
} from "../types/index";

const initialState = {
	isLoading: false,
	success: false,
	network: false,
	failed: false,
	data: {}
};

export default (state = initialState, action) => {
	switch (action.type) {
		case LOADING_ADMINUPDATEMODULEALLOCATION:
			return {
				...state,
				isLoading: true,
				success: false,
				failed: false,
				network: false,
				data: {}
			};
		case ADMINUPDATEMODULEALLOCATION_FAILED:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: true,
				network: false,
				data: action.payload
			};
		case ADMINUPDATEMODULEALLOCATION_SUCCESS:
			return {
				...state,
				isLoading: false,
				success: true,
				failed: false,
				network: false,
				data: action.payload
			};
		case NETWORK_ERROR_ADMINUPDATEMODULEALLOCATION:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: false,
				network: true,
				data: {}
			};
		case RESET_ADMINUPDATEMODULEALLOCATION:
			return (state = initialState);
		default:
			return state;
	}
};
